import React, { Component } from 'react';

import Grid from '@material-ui/core/Grid';

import EnumService from '../../services/Enum';

import Endereco from '../Endereco/EnderecoFilter';

import Filters from '../../components/Filters/Filters';
import Boolean from '../../components/Inputs/Boolean/Boolean';
import Text from '../../components/Inputs/Text/Text';
import SelectOption from '../../components/Inputs/Select/Select';
import Checkbox from '../../components/Inputs/CheckBox/CheckBox';
import { DatePicker } from '../../components/Inputs/DatePicker/DatePicker';

import { parseDate, toDate } from '../../helper/DateHelper';

import { removePagingAndSorting } from '../../helper/PaginationHelper';
import { isAdministradorOuCentral } from '../../security/AuthorizedFunction';
import { patternEnum } from '../../variables/Enums/Enum';

export class ProvaFilter extends Component {
    constructor(props) {
        super(props);
        props.parentRef(this);
        this.state = {
            filters: {
                codigo: '',
                nome: '',
                cpf: '',
                status: '',
                comCandidatoVinculado: '',
                buscarRegiaoGrupo: false,
                salaId: '',
                dataRecebimento: '',
                semInvalidacaoPendente: '',
                comDivergenciaNaoRevisada: '',
                comReservaDigitacaoPresa: '',
                comLeituraMarcacoesSemNotaCalculada: '',
                cortada: '',
                leituraMarcacoesRealizada: '',
                digitalizada: '',
                semFinalizacao: '',
                comProblemasNoCorte: '',
                comProblemasNaLeituraMarcacoes: '',
            },
            count: 0,
            optionsStatusProva: [],
        }
    }

    setEndereco = form => this.Endereco = form;

    // INPUTS
    handleChange = e => {
        this.setState({
            filters: { ...this.state.filters, [e.target.name]: e.target.value }
        });
    };

    handleChecked = e => {
        this.setState({
            filters: { ...this.state.filters, [e.target.name]: e.target.checked }
        });
    };

    handleChangeDate = (e, name) => {
        this.setState({
            filters: { ...this.state.filters, [name]: e }
        });
    };

    // APLICAR PERSISTENCIA
    handleFilterPersistence = (filters) => {
        filters = removePagingAndSorting(filters);

        this.setState({
            filters: {
                codigo: filters.find(f => f.field === 'codigo') ? filters.find(f => f.field === 'codigo').value : "",
                nome: filters.find(f => f.field === 'nome') ? filters.find(f => f.field === 'nome').value : "",
                cpf: filters.find(f => f.field === 'cpf') ? filters.find(f => f.field === 'cpf').value : "",
                status: filters.find(f => f.field === 'status') ? filters.find(f => f.field === 'status').value : "",
                comCandidatoVinculado: filters.find(f => f.field === 'comCandidatoVinculado') ? filters.find(f => f.field === 'comCandidatoVinculado').value : "",
                buscarRegiaoGrupo: filters.find(f => f.field === 'buscarRegiaoGrupo') ? filters.find(f => f.field === 'buscarRegiaoGrupo').value : false,
                salaId: filters.find(f => f.field === 'salaId') ? filters.find(f => f.field === 'salaId').value : "",
                dataRecebimento: filters.find(f => f.field === 'dataRecebimento') ? parseDate(filters.find(f => f.field === 'dataRecebimento').value) : "",
                semInvalidacaoPendente: filters.find(f => f.field === 'semInvalidacaoPendente') ? filters.find(f => f.field === 'semInvalidacaoPendente').value : "",
                comDivergenciaNaoRevisada: filters.find(f => f.field === 'comDivergenciaNaoRevisada') ? filters.find(f => f.field === 'comDivergenciaNaoRevisada').value : "",
                comReservaDigitacaoPresa: filters.find(f => f.field === 'comReservaDigitacaoPresa') ? filters.find(f => f.field === 'comReservaDigitacaoPresa').value : "",
                comLeituraMarcacoesSemNotaCalculada: filters.find(f => f.field === 'comLeituraMarcacoesSemNotaCalculada') ? filters.find(f => f.field === 'comLeituraMarcacoesSemNotaCalculada').value : "",
                cortada: filters.find(f => f.field === 'cortada') ? filters.find(f => f.field === 'cortada').value : "",
                leituraMarcacoesRealizada: filters.find(f => f.field === 'leituraMarcacoesRealizada') ? filters.find(f => f.field === 'leituraMarcacoesRealizada').value : "",
                digitalizada: filters.find(f => f.field === 'digitalizada') ? filters.find(f => f.field === 'digitalizada').value : "",
                semFinalizacao: filters.find(f => f.field === 'semFinalizacao') ? filters.find(f => f.field === 'semFinalizacao').value : "",
                comProblemasNoCorte: filters.find(f => f.field === 'comProblemasNoCorte') ? filters.find(f => f.field === 'comProblemasNoCorte').value : "",
                comProblemasNaLeituraMarcacoes: filters.find(f => f.field === 'comProblemasNaLeituraMarcacoes') ? filters.find(f => f.field === 'comProblemasNaLeituraMarcacoes').value : "",
            },
            count: filters.reduce((total, f) => f.value !== '' ? total + 1 : total, 0),
        })

        this.Endereco.setState({
            filters: {
                UF: filters.find(f => f.field === 'uf') ? filters.find(f => f.field === 'uf').value : "",
                region: filters.find(f => f.field === 'regiao') ? filters.find(f => f.field === 'regiao').value : "",
            }
        }, () => this.Endereco.findCities(true));
    }

    // FILTROS
    handleFilterApply = () => {
        const f = [];
        const { filters } = this.state;

        if (filters.codigo) f.push({ field: 'codigo', value: filters.codigo })
        if (filters.nome) f.push({ field: 'nome', value: filters.nome })
        if (filters.cpf) f.push({ field: 'cpf', value: filters.cpf })
        if (filters.status) f.push({ field: 'status', value: filters.status })
        if (filters.comCandidatoVinculado) f.push({ field: 'comCandidatoVinculado', value: filters.comCandidatoVinculado })
        if (filters.buscarRegiaoGrupo !== null) f.push({ field: 'buscarRegiaoGrupo', value: filters.buscarRegiaoGrupo })
        if (filters.salaId) f.push({ field: 'salaId', value: filters.salaId })
        if (filters.dataRecebimento) f.push({ field: 'dataRecebimento', value: toDate(filters.dataRecebimento) })
        if (filters.semInvalidacaoPendente) f.push({ field: 'semInvalidacaoPendente', value: filters.semInvalidacaoPendente })
        if (filters.comDivergenciaNaoRevisada) f.push({ field: 'comDivergenciaNaoRevisada', value: filters.comDivergenciaNaoRevisada })
        if (filters.comReservaDigitacaoPresa) f.push({ field: 'comReservaDigitacaoPresa', value: filters.comReservaDigitacaoPresa })
        if (filters.comLeituraMarcacoesSemNotaCalculada) f.push({ field: 'comLeituraMarcacoesSemNotaCalculada', value: filters.comLeituraMarcacoesSemNotaCalculada })
        if (filters.cortada) f.push({ field: 'cortada', value: filters.cortada })
        if (filters.leituraMarcacoesRealizada) f.push({ field: 'leituraMarcacoesRealizada', value: filters.leituraMarcacoesRealizada })
        if (filters.digitalizada) f.push({ field: 'digitalizada', value: filters.digitalizada })
        if (filters.semFinalizacao) f.push({ field: 'semFinalizacao', value: filters.semFinalizacao })
        if (filters.comProblemasNoCorte) f.push({ field: 'comProblemasNoCorte', value: filters.comProblemasNoCorte })
        if (filters.comProblemasNaLeituraMarcacoes) f.push({ field: 'comProblemasNaLeituraMarcacoes', value: filters.comProblemasNaLeituraMarcacoes })

        const filtersEndereco = this.Endereco.state.filters;
        if (filtersEndereco.UF) f.push({ field: 'uf', value: filtersEndereco.UF })
        if (filtersEndereco.region) f.push({ field: 'regiao', value: filtersEndereco.region })

        this.props.handleFilterChange(f);        
    }

    // LIMPAR FILTROS
    handleFilterClear = () => {
        this.setState({
            ...this.state,
            filters: {
                codigo: '',
                nome: '',
                cpf: '',
                status: '',
                comCandidatoVinculado: '',
                buscarRegiaoGrupo: false,
                salaId: '',
                dataRecebimento: '',
                semInvalidacaoPendente: '',
                comDivergenciaNaoRevisada: '',
                comReservaDigitacaoPresa: '',
                comLeituraMarcacoesSemNotaCalculada: '',
                cortada: '',
                leituraMarcacoesRealizada: '',
                digitalizada: '',
                semFinalizacao: '',
                comProblemasNoCorte: '',
                comProblemasNaLeituraMarcacoes: '',
            },
            count: 0,
        })

        this.Endereco.limparBuscas();

        this.props.handleFilterChange([], false);
    }

    handleCountFilters = () => this.state.count;

    async componentDidMount() {
        const statusProva = await EnumService.listarStatusProva().then(res => res.data);

        this.setState({
            optionsStatusProva: [...this.state.optionsStatusProva, ...statusProva],
        });
    }

    render() {
        const { filters, optionsStatusProva } = this.state;
        const statusMultiplo = String(filters.status ?? '').includes(',');
        const statusOptions = statusMultiplo
            ? [...optionsStatusProva, { value: filters.status, label: filters.status.split(',').map(s => patternEnum(s, optionsStatusProva)).join(' + ') }]
            : optionsStatusProva;

        return (
            <Filters
                handleFilter={this.handleFilterApply}
                handleFilterClear={this.handleFilterClear}
                countFilters={this.handleCountFilters}
            >                
                <Grid item container spacing={3}>
                    <Grid item sm={12} lg={2}>
                        <Text
                            label="Código"
                            name='codigo'
                            value={this.state.filters.codigo}
                            onChange={(e) => this.handleChange(e)}
                        />
                    </Grid>

                    <Grid item sm={12} lg={4}>
                        <Text
                            label="Nome"
                            name='nome'
                            value={this.state.filters.nome}
                            onChange={(e) => this.handleChange(e)}
                        />
                    </Grid>

                    <Grid item sm={12} lg={2}>
                        <Text
                            label="CPF"
                            name='cpf'
                            value={this.state.filters.cpf}
                            onChange={(e) => this.handleChange(e)}
                        />
                    </Grid>

                    <Grid item sm={12} lg={2}>
                        <SelectOption
                            label="Status"
                            name='status'
                            value={this.state.filters.status}
                            onChange={(e) => this.handleChange(e)}
                            options={statusOptions}
                        />
                    </Grid>
                </Grid>

                <Grid item container spacing={3}>
                    <Grid item sm={12} lg={3}>
                        <Boolean
                            label="Com Candidato Vinculado ?"
                            name='comCandidatoVinculado'
                            value={this.state.filters.comCandidatoVinculado}
                            onChange={(e) => this.handleChange(e)}
                        />
                    </Grid>

                    <Grid item container spacing={3}>
                        <Endereco
                            parentRef={this.setEndereco}
                            withRegion={true}
                            disabledFiltroCR={true}
                            disabledCities={true}
                        />

                        <Checkbox
                            label="Buscar Provas de Toda Região Grupo"
                            name='buscarRegiaoGrupo'
                            checked={this.state.filters.buscarRegiaoGrupo}
                            onChange={(e) => this.handleChecked(e)} 
                        />
                    </Grid>
                </Grid>

                { isAdministradorOuCentral() &&
                    <>
                        <Grid item container spacing={3}>
                            <Grid item sm={12} lg={2}>
                                <Text
                                    label="Sala"
                                    name='salaId'
                                    value={this.state.filters.salaId}
                                    onChange={(e) => this.handleChange(e)}
                                />
                            </Grid>

                            <Grid item sm={12} lg={2}>
                                <DatePicker
                                    disableFuture
                                    label="Data de Recebimento"
                                    name='dataRecebimento'
                                    value={this.state.filters.dataRecebimento}
                                    onChange={(e) => this.handleChangeDate(e, 'dataRecebimento')}
                                />
                            </Grid>
                        </Grid>

                        <Grid item container spacing={3}>
                            <Grid item sm={12} lg={3}>
                                <Boolean
                                    label="Digitalizada?"
                                    name='digitalizada'
                                    value={this.state.filters.digitalizada}
                                    onChange={(e) => this.handleChange(e)}
                                />
                            </Grid>

                            <Grid item sm={12} lg={3}>
                                <Boolean
                                    label="Cortada?"
                                    name='cortada'
                                    value={this.state.filters.cortada}
                                    onChange={(e) => this.handleChange(e)}
                                />
                            </Grid>

                            <Grid item sm={12} lg={3}>
                                <Boolean
                                    label="Leitura de Marcações Realizada?"
                                    name='leituraMarcacoesRealizada'
                                    value={this.state.filters.leituraMarcacoesRealizada}
                                    onChange={(e) => this.handleChange(e)}
                                />
                            </Grid>

                            <Grid item sm={12} lg={3}>
                                <Boolean
                                    label="Sem Finalização?"
                                    name='semFinalizacao'
                                    value={this.state.filters.semFinalizacao}
                                    onChange={(e) => this.handleChange(e)}
                                />
                            </Grid>
                        </Grid>

                        <Grid item container spacing={3}>
                            <Grid item sm={12} lg={3}>
                                <Boolean
                                    label="Com Problemas no Corte?"
                                    name='comProblemasNoCorte'
                                    value={this.state.filters.comProblemasNoCorte}
                                    onChange={(e) => this.handleChange(e)}
                                />
                            </Grid>

                            <Grid item sm={12} lg={3}>
                                <Boolean
                                    label="Com Problemas na Leitura de Marcações?"
                                    name='comProblemasNaLeituraMarcacoes'
                                    value={this.state.filters.comProblemasNaLeituraMarcacoes}
                                    onChange={(e) => this.handleChange(e)}
                                />
                            </Grid>

                            <Grid item sm={12} lg={3}>
                                <Boolean
                                    label="Com Leitura de Marcações Sem Nota Calculada?"
                                    name='comLeituraMarcacoesSemNotaCalculada'
                                    value={this.state.filters.comLeituraMarcacoesSemNotaCalculada}
                                    onChange={(e) => this.handleChange(e)}
                                />
                            </Grid>

                            <Grid item sm={12} lg={3}>
                                <Boolean
                                    label="Com Reserva de Digitação Presa?"
                                    name='comReservaDigitacaoPresa'
                                    value={this.state.filters.comReservaDigitacaoPresa}
                                    onChange={(e) => this.handleChange(e)}
                                />
                            </Grid>
                        </Grid>

                        <Grid item container spacing={3}>
                            <Grid item sm={12} lg={3}>
                                <Boolean
                                    label="Sem Invalidação Pendente?"
                                    name='semInvalidacaoPendente'
                                    value={this.state.filters.semInvalidacaoPendente}
                                    onChange={(e) => this.handleChange(e)}
                                />
                            </Grid>

                            <Grid item sm={12} lg={3}>
                                <Boolean
                                    label="Com Divergência Não Revisada?"
                                    name='comDivergenciaNaoRevisada'
                                    value={this.state.filters.comDivergenciaNaoRevisada}
                                    onChange={(e) => this.handleChange(e)}
                                />
                            </Grid>
                        </Grid>
                    </>
                }
            </Filters>
        )
    }
}

export default ProvaFilter;
